import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import { themeReducer } from "common";
import identityMiddleware from "features/identity/identityMiddleware";
import identityReducer from "features/identity/identitySlice";
import profileMiddleware from "features/profile/profileMiddleware";
import profileReducer from "features/profile/profileSlice";
import { combineReducers } from "redux";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  //blacklist: ["navigation"], // navigation will not be persisted
  whitelist: [
    "theme",
    "identity",
    "profile",
    "clientSelector",
    "notifications",
  ],
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    identity: identityReducer,
    profile: profileReducer,
    theme: themeReducer,
  })
);
let middlewares = [identityMiddleware, profileMiddleware];

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(middlewares),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
